<template>
  <!--<div v-html="video.embed_html"></div>-->
  <div id='player-layer'>
    <iframe v-if='video.video_id' v-bind:width="width" v-bind:height="height" v-bind:src="'//www.youtube.com/embed/' + video.video_id" frameborder="0" allowfullscreen="false"></iframe>
  </div>
</template>
<script>
  export default {
    name: 'video-item',
    props: ['video'],
    data () {
      return {
        page: 1,
        width: 480,
        height: 270,
        aspectRatio: '16:9',
        keyword: ''
      }
    },
    mounted () {
      this.width = document.documentElement.clientWidth
      this.height = this.width * (9 / 16)
    },
    updated () {
      // document.querySelector('.mdl-tabs__tab:nth-child(2)').querySelector('span').click()
      // window.$('.menu .item').tab('change tab', 'player-panel')
      window.ga('send', 'event', 'see', 'vuejs', this.video_id)
    },
    methods: {
    }
  }
</script>
<style>
#player-layer {
  position: fixed;
  margin-right: 2em;
  margin-bottom: 2em;
  bottom: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// VideoItem.vue?0383c25e